var OwlfonsoContainer = require('components/utility/OwlfonsoContainer');

require("writing/questions/question_feedback.scss")

class QuestionFeedback extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("QuestionFeedback");
		this.state = { showCount: 1 };
	}

	showMore(e) {
		$wr.nope(e)
		this.setState({ showCount: this.state.showCount + 1 })
	}
	// send data and reason to parent
	onFeedbackOverride(data, reason, e) {
		$wr.nope(e)
		if (this.state.showCount > 1) {
			this.setState({ showCount: this.state.showCount - 1 })
		}
		this.props.onFeedbackOverride(data, reason)
	}

	render() {
		var visibleFeedback = _.first(this.props.feedbackItems, this.state.showCount);
		var feedbackDisplays = _.map(visibleFeedback, (itemGroup, index) => {
			// checks if the feedback can be overridden
			if (itemGroup.data) {
				return (
					<OwlfonsoContainer key={index + itemGroup.data.trigger} hideOwl={index < this.state.showCount - 1}
						owlPosition="bottom-left" initialAnimation={true} owlWidth={80}
						showFeedbackReward={this.props.showFeedbackReward}
						feedbackToRead={$wr.getInnerText(itemGroup)}
						onFeedbackOverride={this.onFeedbackOverride}
						feedbackObj={itemGroup.data}>
						{itemGroup}
					</OwlfonsoContainer>
				);
			} else {
				return (
					<OwlfonsoContainer key={index + $wr.getInnerText(itemGroup).replaceAll(' ', '_')} hideOwl={index < this.state.showCount - 1}
						owlPosition="bottom-left" initialAnimation={true} owlWidth={80}
						showFeedbackReward={this.props.showFeedbackReward}
						feedbackToRead={$wr.getInnerText(itemGroup)} >
						{itemGroup}
					</OwlfonsoContainer >
				)
			}
		});

		if (this.state.showCount < this.props.feedbackItems.length) {
			var moreLink = (
				<p className="showMore text-right">
					<a href="#" onClick={ this.showMore }>Tell Me More</a>
				</p>
			);
		}

		return (
			<div className="questionFeedback">
				{ feedbackDisplays }
				{ moreLink }
			</div>
		);
 	}
};

QuestionFeedback.propTypes = StrictPropTypes({
	feedbackItems: PropTypes.array.isRequired,
	// IF true, show reward for taking feedback into account
	showFeedbackReward: PropTypes.bool,
	onFeedbackOverride: PropTypes.func,
});

module.exports = QuestionFeedback;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/QuestionFeedback.js